import { SignUp } from "@clerk/nextjs";
import PageIntro from "components/content/PageIntro/PageIntro";
import { site } from "config";
import { fetchLayoutDataServer } from "lib/api/strapi-layout";
import { useState } from "react";
import Layout from "../../components/Layout";

import Consent from "@/components/auth/clerk/Consent";
import styles from "./sign-up.module.scss";

export default function SignUpPage({ layoutData }) {
  const [communicationConsent, setCommunicationConsent] = useState(false);
  const seo = {
    metaDescription: "Sign up for your Where Next account.",
    metaTitle: "WhereNext | Sign Up",
    canonicalURL: `${site}/sign-up`,
  };

  const handleConsentCheckboxChange = (event) => {
    setCommunicationConsent(event.target.checked);
  };

  return (
    <Layout layoutData={layoutData} showEmailSignup={false} seo={seo}>
      <main className={`${styles.signUp} variable-container`}>
        <PageIntro title="Sign Up" />
        <div className={`${styles.signUpElement}`}>
          <SignUp
            path="/sign-up"
            routing="path"
            unsafeMetadata={{ communicationConsent }}
          />
          <div className={`${styles.consentContainer}`}>
            <Consent
              handleConsentCheckboxChange={handleConsentCheckboxChange}
              checked={communicationConsent}
            />
          </div>
        </div>
      </main>
    </Layout>
  );
}
export async function getStaticProps(context) {
  // const layoutData = await fetchLayoutData();
  const layoutData = await fetchLayoutDataServer();

  return {
    props: {
      layoutData: layoutData,
    },
  };
}

export async function getStaticPaths(index) {
  return {
    paths: [],
    fallback: "blocking",
  };
}
